export const validateEmptyOrNull = (value) => {
    return [null, undefined, "undefined", "", "null"].includes(value) ? true : false;
};